
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "xmlns": "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    "width": "16px",
    "height": "15px"
  },
  "children": [
    {
      "tag": "path",
      "attrsMap": {
        "fill-rule": "evenodd",
        "fill": "rgb(148, 155, 174)",
        "d": "M11.811,4.305 C10.766,4.305 9.920,3.465 9.920,2.430 C9.920,1.394 10.766,0.555 11.811,0.555 C12.855,0.555 13.702,1.394 13.702,2.430 C13.702,3.465 12.855,4.305 11.811,4.305 ZM11.702,4.383 C13.545,4.383 15.038,7.804 15.038,11.056 C15.038,11.062 12.376,11.065 10.415,11.064 C10.952,11.061 11.309,11.059 11.309,11.056 C11.309,9.058 10.744,6.926 9.883,5.576 C10.406,4.841 11.030,4.383 11.702,4.383 ZM7.994,4.189 C7.987,4.189 7.980,4.187 7.973,4.187 C7.829,4.187 7.689,4.216 7.550,4.258 C7.430,4.224 7.311,4.187 7.188,4.187 C7.106,4.187 7.025,4.202 6.944,4.216 C6.180,3.983 5.620,3.276 5.620,2.430 C5.620,1.394 6.452,0.555 7.479,0.555 C8.506,0.555 9.338,1.394 9.338,2.430 C9.338,3.279 8.763,3.961 7.994,4.189 ZM7.580,4.383 C9.423,4.383 10.917,7.804 10.917,11.056 L4.244,11.056 C4.244,7.804 5.738,4.383 7.580,4.383 ZM4.746,11.064 C2.785,11.065 0.123,11.062 0.123,11.056 C0.123,7.804 1.616,4.383 3.459,4.383 C4.131,4.383 4.755,4.841 5.278,5.576 C4.417,6.926 3.852,9.058 3.852,11.056 C3.852,11.059 4.209,11.061 4.746,11.064 ZM3.341,4.305 C2.315,4.305 1.483,3.465 1.483,2.430 C1.483,1.394 2.315,0.555 3.341,0.555 C4.368,0.555 5.200,1.394 5.200,2.430 C5.200,3.465 4.368,4.305 3.341,4.305 ZM15.027,14.875 L0.125,14.875 L0.125,11.739 L15.027,11.739 L15.027,14.875 Z"
      }
    }
  ]
})
    }
  